<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MnQbQo/tc-custom/9781466881723.jpg?1740715988194" alt="This image is the cover for the book Ancestral Truths"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ancestral Truths
      </h1>
      <p class="bookDescription body article font2">
        <p>There were three possible reasons given for the disappearance of the two hikers on Mount Nyangani: the treacherous terrain and climate; the <i>banditos armados;</i> the unforgiving spirit called Chirikuzi. In David' case there was a fourth--that Clare might have killed him.<br/><br/>Unable to remember exacly what happened on the mountain in Zimbabwe and trying to come to terms with the loss of her hand in the accident, Clare is taken home to Scotland where her large, loving, questioning, and uncomfortably acute family become almost unbearable. She had wanted David dead, but did that mean she had killed him? Her mother's High Church concern, Anni's sharp-tongued radicalism, santly Felicity's internal fury, and her deaf niece Alice's fascination with the prosthetic hand seem at first to distract from Clare's problems, until the aristocratic family's pieties pierce her cocoon of post-traumatic amnesia.<br/><br/>Family resentments flare and fade, divisions fester and heal, and as clare uncovers buried fears, she comes to understand that the real question about the accident on Mount Nyangani is less what she has forgotten than why.<br/><br/>Intricate in design, disturbing in its explorations of mind and spirit, and with a surprising twist at the end, <i>Ancestral Truths </i>employs a striking narrative voice to explore the shifting relations between belief and truth, love and desire, to reveal that beauty and danger walk hand in hand. Sara Maitland summons her knowledge of theology, mysticism, mathematics, and human nature to give this deeply perceptive novel its wit and cohesive richness. As Ms. Maitland's characters gradually recognize the inseparability of their strengths and weaknesses, the authof of <i>Three Times Table</i> raises her art to a new pitch of excitement and originality.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sara Maitland
      </h2>
      
      <p class="authorDescription body article"><P>Sara Maitland was born in Scotland and now lives in London. She won Britain's coveted Somerset Maugham Award for her first novel, <I>Daughter of Jerusalem.</I> Her study of women and Christianity resulted in a groundbreaking nonfiction title, <I>A Map of the New Country. Three Times Table, </I>a novel published by Holt to generous critical acclaim in 1991, will be reissued as an Owl paperback to coincide with the publication of <I>Ancestral Truths.</I></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Henry Holt and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?69cc530c